import { FieldRenderProps, FieldWrapper } from "@progress/kendo-react-form";
import { NumericTextBox } from "@progress/kendo-react-inputs";
import { Label, Error, Hint } from "@progress/kendo-react-labels";

export default function FormNumericTextBox(fieldRenderProps: FieldRenderProps) {
    const {
        validationMessage,
        touched,
        label,
        id,
        valid,
        disabled,
        hint,
        optional,
        min,
        wrapperStyle,
        title,
        ...others
    } = fieldRenderProps;

    const showValidationMessage = touched && validationMessage;
    const showHint = !showValidationMessage && hint;
    const hintId = showHint ? `${id}_hint` : '';
    const errorId = showValidationMessage ? `${id}_error` : '';

    return (
        <FieldWrapper style={wrapperStyle}>
            {label && <Label
                editorId={id}
                editorValid={valid}
                editorDisabled={disabled}
                optional={optional}
            >
                {label}
            </Label>}
            <div className={'k-form-field-wrap'}>
                <NumericTextBox
                    valid={valid}
                    id={id}
                    className='customInput'
                    disabled={disabled}
                    aria-describedby={`${hintId} ${errorId}`}
                    title={title}
                    min={min}
                    {...others}
                />
                {showHint && <Hint id={hintId}>{hint}</Hint>}
                {showValidationMessage && (
                    <Error id={errorId}>{validationMessage}</Error>
                )}
            </div>
        </FieldWrapper>
    );
};